import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

/**
 * Preset de PrimeNG para EVOLTI.
 * Los valores salen de las variables de evolti-tokens.css; aquí solo se mapean a los tokens de PrimeNG.
 * Solo se define el esquema claro. El oscuro se añadirá redefiniendo los tokens bajo `.dark`.
 */
export const EvoltiPreset = definePreset(Aura, {
  primitive: {
    borderRadius: {
      none: '0',
      xs: 'var(--ev-radius)',
      sm: 'var(--ev-radius)',
      md: 'var(--ev-radius)',
      lg: 'var(--ev-radius)',
      xl: 'var(--ev-radius)',
    },
  },
  semantic: {
    primary: {
      50: 'var(--ev-blue-50)',
      100: 'var(--ev-blue-100)',
      200: 'var(--ev-blue-200)',
      300: 'var(--ev-blue-300)',
      400: 'var(--ev-blue-400)',
      500: 'var(--ev-blue-500)',
      600: 'var(--ev-blue-600)',
      700: 'var(--ev-blue-700)',
      800: 'var(--ev-blue-800)',
      900: 'var(--ev-blue-900)',
      950: 'var(--ev-blue-950)',
    },
    colorScheme: {
      light: {
        surface: {
          0: 'var(--ev-white)',
          50: 'var(--ev-gray-50)',
          100: 'var(--ev-gray-100)',
          200: 'var(--ev-gray-200)',
          300: 'var(--ev-gray-300)',
          400: 'var(--ev-gray-400)',
          500: 'var(--ev-gray-500)',
          600: 'var(--ev-gray-600)',
          700: 'var(--ev-gray-700)',
          800: 'var(--ev-ink-800)',
          900: 'var(--ev-ink-900)',
          950: 'var(--ev-black)',
        },
        primary: {
          color: 'var(--ev-color-primary)',
          contrastColor: 'var(--ev-color-on-primary)',
          hoverColor: 'var(--ev-color-primary-hover)',
          activeColor: 'var(--ev-color-primary-active)',
        },
        text: {
          color: 'var(--ev-color-text)',
          hoverColor: 'var(--ev-color-text)',
          mutedColor: 'var(--ev-color-text-muted)',
          hoverMutedColor: '{surface.600}',
        },
      },
    },
  },
});
